import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { List } from 'immutable';
import { Observable } from 'rxjs/Observable';
import { Attachment } from '../../models/attachment';
import { EnvironmentConfiguration } from 'app/environment/services/environment.configuration';
import { ResponseUtilService } from '../../../shared/utils/response-util.service';
import { AppAuthHttpService } from '../../../http/app.auth.http.service';

@Injectable()
export class AttachmentHttpService {
  private eventsUrl: string = this.environment.baseUrl + '/api/events';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  getForEvent(eventId: number): Observable<List<Attachment>> {
    return this.http.get(`${this.eventsUrl}/${eventId}/attachments`)
      .map((res: Response) => res.json())
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  add(eventId: number, file: File): Observable<any> {
    let formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.eventsUrl}/${eventId}/attachments`, formData)
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  get(uniqueId: string): Observable<string> {
    return this.http.get(`${this.eventsUrl}/attachments/${uniqueId}`)
      .map(resp => resp.text())
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  delete(uniqueId: string): Observable<any> {
    return this.http.delete(`${this.eventsUrl}/attachments/${uniqueId}`)
      .catch(response => this.responseUtilService.handleError(response)).share();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/attachment/attachment.http.service.ts